import { Config } from "@/shared/config";

const billingServiceUri = Config.BillingServicebaseUri;

export default {
  get billingV1 (): string {
    return `${billingServiceUri}/billing/v1`;
  },
  employerPayer (employerId: number) {
    return `${this.billingV1}/employerpayer/${employerId}`;
  },
  feeSchedule () {
    return `${this.billingV1}/fee-schedule`;
  },
  partnerBilling (partnerId: number) {
    return `${this.billingV1}/partner/${partnerId}/billing`;
  },
  individualFee (partnerId: number) {
    return `${this.billingV1}/partner/${partnerId}/individual-fee`;
  },
  partnerFeeCollection (partnerId: number) {
    return `${this.billingV1}/partner/${partnerId}/fee-collection`;
  },
  employerFeeCollection (employerId: number) {
    return `${this.billingV1}/employer/${employerId}/fee-collection`;
  },
  getMonthlyBillingPeriods () {
    return `${this.billingV1}/billingreport/periods`;
  },
  getMonthlyBillingPeriodsByPartner (partnerId: number) {
    return `${this.billingV1}/billingreport/periods/employergroup/partner/${partnerId}`;
  },
  getMonthlyBillingPeriodsByEmployer (employerId: number) {
    return `${this.billingV1}/billingreport/periods/employer/${employerId}`;
  },
  downloadReport (periodId: number) {
    return `${this.billingV1}/billingreport/download/${periodId}`;
  },
  getReconBillingPeriods (): string {
    return `${this.billingV1}/billingreport/periods/feerecon`;
  },
  downloadReconReport (periodId: number) {
    return `${this.billingV1}/billingreport/download/feerecon/${periodId}`;
  },
  downloadPartnerReport (partnerId: number, billingPeriodId: number, employerId: null | number) {
    const erIdOrEmptyStr = (employerId !== null) ? `/${employerId}` : "";
    return `${this.billingV1}/billingreport/partner/${partnerId}/download/${billingPeriodId}${erIdOrEmptyStr}`;
  },
  downloadEmployerReport (employerId: number, billingPeriodId: number) {
    return `${this.billingV1}/billingreport/employer/${employerId}/download/${billingPeriodId}`;
  },
  downloadSummaryReport (periodId: number) {
    return `${this.billingV1}/billingreport/download/summary/${periodId}`;
  },
  getReconBillingPeriodsForPartner (partnerId: number) {
    return `${this.billingV1}/billingreport/periods/employergroup/partner/${partnerId}/feesettlement`;
  },
  downloadReconReportForPartner (partnerId: number, periodId: number, employerId: null | number) {
    const erIdOrEmptyStr = (employerId !== null) ? `/${employerId}` : "";
    return `${this.billingV1}/billingreport/partner/${partnerId}/download/feerecon/${periodId}${erIdOrEmptyStr}`;
  },
  partnerFeeWaiver (partnerId: number) {
    return `${this.billingV1}/partner/${partnerId}/individual-fee/waiver`;
  },
  agreeToFeeTerms () {
    return `${this.billingV1}/user/agreefeeterms`;
  },
  billingHistoryYears () {
    return `${this.billingV1}/billing-history/years`;
  },
  billingHistoryMonthSummaries (year: number) {
    return `${this.billingV1}/billing-history/${year}`;
  },
  partnerInvestmentFeeSchedule (partnerId: number) {
    return `${this.billingV1}/investment-fee-schedule/partner/${partnerId}`;
  },
  employerInvestmentFeeSchedule (employerId: number) {
    return `${this.billingV1}/investment-fee-schedule/employer/${employerId}`;
  }
};
